import axios from '@/axios'

export default {
  getAllByType(type) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/metadata/type/${type}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  add(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/metadata`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  update(item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/metadata`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  remove(item) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/metadata/${item.id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getLinks(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/metadata/link/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  addLink(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/metadata/link`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  removeLink(item) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/metadata/link/${item.id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
